import request from "../_redux/utils/request";

export async function addProfile(file) {
  const formData = new FormData();
  formData.append("file", file);

  return request({
    url: "/add-profile",
    method: "POST",
    isMultipart: true,
    formData
  });
}

export async function getProfile() {
  return request({
    url: "/users/profile",
    method: "GET"
  });
}

export async function updateProfile(payload) {
  return request({
    url: "/users/profile",
    method: "PUT",
    body: payload
  });
}

export async function deleteReport(reportId) {
  return request({
    url: `/users/profile/reports/${encodeURIComponent(reportId)}`,
    method: "DELETE"
  });
}
